import { render, staticRenderFns } from "./Thematics.vue?vue&type=template&id=2b721229&"
import script from "./Thematics.vue?vue&type=script&lang=js&"
export * from "./Thematics.vue?vue&type=script&lang=js&"
import style0 from "./Thematics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports